import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from './AuthContext';
import { getSocketBaseUrl } from '../lib/api';

const AdminSocketContext = createContext(null);

export const AdminSocketProvider = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const [socket, setSocket] = useState(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      setSocket(null);
      setConnected(false);
      return;
    }

    const token = localStorage.getItem('adminToken');
    const socketUrl = getSocketBaseUrl();
    const newSocket = io(socketUrl, {
      transports: ['websocket', 'polling'],
      auth: { token }
    });

    newSocket.on('connect', () => {
      setConnected(true);
      if (token) {
        newSocket.emit('admin:authenticate', { token });
      }
    });

    newSocket.on('disconnect', () => setConnected(false));
    newSocket.on('connect_error', () => setConnected(false));

    setSocket(newSocket);
    return () => newSocket.disconnect();
  }, [isAuthenticated]);

  const value = useMemo(() => ({
    socket,
    connected,
    subscribeToSession: (sessionId) => {
      if (socket && connected && sessionId) {
        socket.emit('admin:subscribe:session', { sessionId });
      }
    },
    unsubscribeFromSession: (sessionId) => {
      if (socket && connected && sessionId) {
        socket.emit('admin:unsubscribe:session', { sessionId });
      }
    }
  }), [socket, connected]);

  return <AdminSocketContext.Provider value={value}>{children}</AdminSocketContext.Provider>;
};

export const useAdminSocket = () => useContext(AdminSocketContext);
